import { render, staticRenderFns } from "./SingleEOD.vue?vue&type=template&id=16bafae6&scoped=true"
import script from "./SingleEOD.vue?vue&type=script&lang=js"
export * from "./SingleEOD.vue?vue&type=script&lang=js"
import style0 from "./SingleEOD.vue?vue&type=style&index=0&id=16bafae6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bafae6",
  null
  
)

export default component.exports